import '@babel/polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './plugins/vuetify'
import App from './App'
import router from './router'
import store from './store'
import ProgressBar from './components/ProgressBar'
import Vuetify from 'vuetify'
import VueTour from 'vue-tour'
import 'vuetify/dist/vuetify.min.css'
import 'toastr/build/toastr.min.css'
import 'vue-tour/dist/vue-tour.css'

Vue.use(Vuetify)
Vue.use(VueTour)
// import VueScrollTo from 'vue-scrollto'

Vue.config.productionTip = false

router.beforeResolve((to, from, next) => {
  if (from.name !== null) {
    // since we're not landing on the page fire pageviews...
    window.fbq('track', 'PageView')
    window.gtag('config', 'UA-96115218-1', {'page_path': to.path})
  }
  next()
})

// global progress bar
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js